/**
 * About Page Code
 *
 * Each unique page (or template) has its own page script.  These
 * scripts are loaded into the template, along with the main.js
 * script, and any vendor scripts needed for the site.  The
 * individual page scripts add a 'page' object into the main
 * Otto namespace, and the main.js file then init()'s this
 * page object to execute whatever page-specific code needs
 * to be run.
 */

/* global jQuery */

var Otto = Otto || {};
Otto.page = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {},
        $donationsForm = null,
        $foodDonationsForm = null,
        $foodDonationStateSelect = null,
        $foodDonationLocSelect = null,
        $foodDonationLocSelectValue = null,
        foodDonationsCurrState = '';


    function wireEvents() {
        var $item = null;

        // Hook up in-page links (for scrolling between sections)
        $('.inpage-links__link--work-at-otto').click(function(evt){
            evt.preventDefault();
            $(window).scrollTo('#work', 750);
        });
        $('.inpage-links__link--history').click(function(evt){
            evt.preventDefault();
            $(window).scrollTo('#history', 750);
        });
        $('.inpage-links__link--fundraiser-donation-overview').click(function(evt){
            evt.preventDefault();
            // We now link to the intro for the forms section...
            $(window).scrollTo('#fundraiser-donation-overview', 750);
        });
        /*
        $('.inpage-links__link--donations').click(function(evt){
            evt.preventDefault();
            $(window).scrollTo('#donations', 750);
            // Let's also open the form element
            $item = $('.form-wrapper--donations');
            toggleIt($item);
        });
        */

        // Hook up the acceptance checkbox (reveals forms when clicked)
        $('#accept').change(function(event) {
            if (this.checked) {
                $('#fundraiser-donation-wrapper').slideDown();
                $(window).scrollTo('#fundraiser-donation-wrapper', 750);
            } else {
                $('#fundraiser-donation-wrapper').slideUp();
            }
        });

        // Hook up expand/collapse functionality on forms
        $('.form__title-icon, .form__title-text').click(function(evt){
            evt.preventDefault();
            $item = $(evt.target).closest('.form-wrapper');
            toggleIt($item);
        });

        
        // ----------------------------------------------------------
        // IN-KIND DONATIONS FORM
        // ----------------------------------------------------------
        // Hook up In-kind Donations form for ajax posting
        // NOTE: Fundraiser form is managed through a separate 
        // module (below)
        
        $donationsForm.on('submit', processFormSubmission);


        // ----------------------------------------------------------
        // FOOD DONATIONS FORM
        // ----------------------------------------------------------
        // Hook up Food Donations form for ajax posting
        // NOTE: Fundraiser form is managed through a separate 
        // module (below)
        
        $foodDonationsForm.on('submit', processFormSubmission);
        

        // General Form Processing ----------------------------------
        function processFormSubmission(evt) {
            var $form = $(this);
            var formData = new FormData($form[0]); // $form.serialize();
            evt.preventDefault();

            deactivateForm($form);

            $.ajax({
                url : '',
                method: 'POST',
                data: formData,
                async: true,
                cache: false,
                contentType: false,
                processData: false,
                success: function(response, textStatus, jqXHR){
                    // handle server response
                    // console.log(response);
                    if (response.ok == 'yes') {
                        handleSuccess($form);
                    } else {
                        activateForm($form);
                        handleIncomplete($form, response.errors);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown){
                    //do something for error
                    alert('We\'re sorry, but please try again later.');
                    activateForm($form);
                    console.log('errorThrown: ', errorThrown);
                    console.log('textStatus: ', textStatus);
                }
            });

            return false;
        }


        // Food Donation Field Prep ---------------------------------

        // Called when a state is selected - preps the 'location' field
        // with locations relevant to the current state.  Do nothing
        // if selection is same as current value.
        function doStateSelect(state) {

            // Convert value chosen from dropdown into useable,
            // abbreviated form.  We use 'full words' in the
            // dropdown, as that is what gets sent to the
            // site admin when a selection is made.
            switch (state) {
                case 'Massachusetts':
                    state = 'ma';
                    break;
                case 'Maine':
                    state = 'me';
                    break;
                case '':
                    // null selection was made - technically valid
                    break;
                default:
                    alert('State selection is not valid.');
                    return;
            }

            if (state === foodDonationsCurrState) return;

            // Set our new state value
            foodDonationsCurrState = state;

            if (foodDonationsCurrState === '') {
                // Means a null selection was made - clear out the
                // locations field as well and abort
                resetLocations();
                setLocationsActive(false);
                return;
            }

            // Populate location select field for the selected state
            setLocationsData(foodDonationsCurrState);

            // Activate the location list
            setLocationsActive(true);
        }

        // Called when a location is selected.  We need to update the 
        // actual (hidden) field read in by the form processor (the 
        // dropdown that is shown is dynamically created, and not 
        // part of the form's database of fields).
        function doLocationSelect(locId, locText, calId, days) {
            $foodDonationLocSelectValue.val(locText);
        }
        function resetLocations() {
            $foodDonationLocSelect.val('');
        }
        function setLocationsActive(val) {
            $foodDonationLocSelect.prop('disabled', !val);
        }
        function setLocationsData(state) {
            var dataList,
                optionStr,
                id, label;
    
            dataList = $('.' + state + '-locations li');
            $foodDonationLocSelect.find('option').remove();
            optionStr = '<option value="">--</option>';
            $foodDonationLocSelect.append(optionStr);
            $.each(dataList, function(index, el) {
                id          = $(el).data('id');
                label       = $(el).data('label');
                optionStr   = '<option value="'+ id + '">' +
                              label +'</option>';
                $foodDonationLocSelect.append(optionStr);
            });
        }

        // Hook up food donation state select field
        $foodDonationStateSelect.change(function(evt){
            // Handle state selection
            doStateSelect($(this).val());
        });
        $foodDonationLocSelect.change(function(evt) {
            // Handle location selection
            var selectedItem, locId, locText;
            selectedItem = $(this).find(':selected');
            locId   = selectedItem.val();
            locText = selectedItem.text();
            doLocationSelect(locId, locText);
        });
    }

    // Handle form toggle open/closed
    function toggleIt($item) {
        $item.toggleClass('form-wrapper--is-active');
        if ($item.hasClass('form-wrapper--is-active')) {
            $item.find('.form__content-container').slideDown();
        } else {
            $item.find('.form__content-container').slideUp();
        }
    }

    // Handle successful form submission.
    function handleSuccess($formRef) {
        var msg = '<div class="ok">';
        msg += '<h3>Message Sent!</h3>';
        msg += '<p>Thank you for submitting your inquiry. ';
        msg += 'We will be in contact with you shortly.</p></div>';
        $formRef.parent().append(msg);
        $formRef.slideUp();
    }

    // Handle form submission errors
    function handleIncomplete($formRef, errData) {
        var err = '<div id="errorList">';
        err += '<h3>Please correct the following errors:</h3>';
        err += '<ul class="error-list">';
        for (var item in errData) {
            err += '<li>' + errData[item] + '</li>';
        }
        err += '</ul>';
        // Remove existing errors (if any)
        $formRef.find('#errorList').remove();
        // Then add our new list
        $formRef.find('.form__error-messaging').after(err);
        $(window).scrollTo('#' + $formRef.attr('id') + ' #errorList', 750);
    }

    function deactivateForm($formRef) {
        var submitBtn = $formRef.find('.submit'),
            loader = $formRef.find('.form__loader');
        submitBtn.prop('disabled', true);
        submitBtn.addClass('form__button-inactive');
        loader.addClass('is-opaque');
    }

    function activateForm($formRef) {
        var submitBtn = $formRef.find('.submit'),
            loader = $formRef.find('.form__loader');
        submitBtn.prop('disabled', false);
        submitBtn.removeClass('form__button-inactive');
        loader.removeClass('is-opaque');
    }


    exports.init = function() {
        // Set up some references
        $donationsForm = $('#donationRequest');
        $foodDonationsForm = $('#foodDonationRequest');
        $foodDonationStateSelect = $('#foodDonationRequest_state');
        $foodDonationLocSelect = $('#foodDonation-select-location');
        $foodDonationLocSelectValue = $('#foodDonationRequest_location');

        // Initialize form expansion (hide content to start)
        $('.form-wrapper').find('.form__content-container').hide();

        // Initialize timeline scrolling
        $('.timeline').niceScroll(
                            {railpadding:{top:1,right:2,left:2,bottom:1},
                             cursorborder:"0",
                             cursorcolor:"#222222",
                             touchbehavior:true,
                             hidecursordelay:1000});

        wireEvents();

        // If the fundraisers module is present, initialize it
        if (Otto.hasOwnProperty('fundraiserForm')) {
            Otto.fundraiserForm.init();
        }
    };

    return exports;

})(Otto, jQuery);



// Create a separate module for the fundraiser form functionality
Otto.fundraiserForm = (function(my, $) {
    // Create object for storing our methods for public consumption
    // (this sets up our external API for this module)
    var exports = {},
        currState = null,
        currLoc = null,
        $form = null,
        $stateSelect = null,
        $locSelect = null,      //
        $locSelectValue = null, // hidden field used to store Formerly location value
        $date1 = null,
        $date2 = null,
        $date3 = null,
        dateFields = null,
        pickers = null,
        currTakenDates = null,  // track the selected and/or unavailable dates
        calEvents = {};

    // Called when a state is selected - clears out the current
    // date selections (if any) and preps the 'location' field
    // with locations relevant to the current state.  Do nothing
    // if selection is same as current value.
    function doStateSelect(state) {

        // Convert value chosen from dropdown into useable,
        // abbreviated form.  We use 'full words' in the
        // dropdown, as that is what gets sent to the
        // site admin when a selection is made.
        switch (state) {
            case 'Massachusetts':
                state = 'ma';
                break;
            case 'Maine':
                state = 'me';
                break;
            case '':
                // null selection was made - technically valid
                break;
            default:
                alert('State selection is not valid.');
                return;
        }

        if (state === currState) return;

        // Set our new state value
        currState = state;

        // If a state selection is made, we need to block out
        // the date fields until a location is selected
        resetDates();
        setDatesActive(false);

        if (currState === '') {
            // Means a null selection was made - clear out the
            // locations field as well and abort
            resetLocations();
            setLocationsActive(false);
            return;
        }

        // Populate location select field for the selected state
        setLocationsData(currState);

        // Check to see if we have event data listed for the
        // requested state.  If not, load it up.
        if (calEvents[currState] === undefined) {
            setLocationsActive(false);
            loadCalEvents(currState);
            return;
        }

        // Activate the location list
        setLocationsActive(true);
    }

    // Called when a location is selected.  We need to clear out any
    // existing dates, and then prep the date selection fields to
    // display the correct list of available dates.
    function doLocationSelect(locId, locText, calId, days) {

        if (locId === currLoc) return;

        // Set the current location
        currLoc = locId;

        // Set the hidden field (the one that Formerly looks at)
        // to the value of the user selection.
        $locSelectValue.val(locText);

        // Prep date fields
        resetDates();
        prepDateFields(currState, calId, days);
        setDatesActive(true);
    }

    function resetLocations() {
        $locSelect.val('');
    }
    function setLocationsActive(val) {
        $locSelect.prop('disabled', !val);
    }
    function setLocationsData(state) {
        var dataList,
            optionStr,
            id, calId, label, days;

        dataList = $('.' + state + '-location-data li');
        $locSelect.find('option').remove();
        optionStr = '<option value="">--</option>';
        $locSelect.append(optionStr);
        $.each(dataList, function(index, el) {
            id          = $(el).data('id');
            calId       = $(el).data('calendar-id');
            label       = $(el).data('label');
            days        = $(el).data('days');
            optionStr   = '<option value="'+ id +
                          '" data-calendar-id="'+ calId +
                          '" data-days="'+ days +'">'+
                          label +'</option>';
            $locSelect.append(optionStr);
        });
    }

    // Here, we reset the dates to empty values
    function resetDates() {
        $.each(pickers, function(index, picker) {
            // Clear out any selected dates
            picker.set('clear');
        });
    }
    function setDatesActive(val) {
        $.each(dateFields, function(index, el) {
            el.prop('disabled', !val);
        });
    }

    // Here, we prepare the date field selectors, enabling only the dates
    // that A) are available for this location, and B) have not already
    // been scheduled by someone else (per Google Calendar info)
    function prepDateFields(state, calId, days) {
        var evtData,
            availDays;

        evtData = calEvents[state][calId].busy;
        // Set unavailable days of the week first...
        // NOTE: the days that are passed in are the days AVAILABLE for
        // selection.  Need to flip this.
        availDays = [];
        if (typeof days === 'string') {
            // Means we have multiple days available.  Break em up.
            days.split(',').forEach(function(el){
                availDays.push(parseInt(el,10));
            });
        } else {
            availDays.push(parseInt(days, 10));
        }

        currTakenDates = [];
        [1,2,3,4,5,6,7].forEach(function(el){
            if (availDays.indexOf(el) < 0) {
                // This is NOT an available day for events -- add it
                // to the 'taken' (unavailable) array.
                currTakenDates.push(el);
            }
        });

        // JG EDIT: Block out entire year for now...
        currTakenDates.push({ from: [2020, 0, 1], to: [2020, 11, 31] });

        
        for (var item in evtData) {
            var busyDate = evtData[item];
            currTakenDates.push(new Date(busyDate.start));
        }
        // console.log('currTakenDates:', currTakenDates);

        $.each(pickers, function(index, picker) {
            initPicker(picker);
        });
    }

    function initPicker(picker) {
        // Reset all dates to be enabled
        picker.set('enable', true);
        // Then specify specifics for our current location
        picker.set({
            disable: currTakenDates
        });
    }


    // Here, we query Google calendar's API to find any existing
    // events for the requested calendar.
    function loadCalEvents(state) {
        var calId,
            dataList,
            idArr,
            freeBusyQuery,
            minDate,
            maxDate;

        // Gather a collection of cal ID's to query on for curr state
        idArr = [];
        dataList = $('.' + state + '-location-data li');
        $.each(dataList, function(index, el) {
            var calId = $(el).data('calendar-id');
            idArr.push({"id": calId});
        });

        // Now, build our query for the API
        minDate = new Date();
        maxDate = new Date();
        maxDate = Otto.util.addDays(maxDate, 90);
        freeBusyQuery = {
            "timeMin": minDate, // "2016-01-01T00:00:00-05:00",
            "timeMax": maxDate,
            "items": idArr
        };

        $.ajax({
            type: 'POST',
            url: 'https://www.googleapis.com/calendar/v3/freeBusy?fields=calendars,timeMax,timeMin&key=' + apikey,
            data: JSON.stringify(freeBusyQuery),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            processData: true,
            success: function (response) {
                calEventsLoadComplete(response.calendars, state);
            },
            error: function (response) {
                //tell that an error has occurred
                console.log("ERROR");
                console.log(response.responseText);
                alert("We're sorry, but please try again later.");
            }
        });
    }

    // Callback processor for our google calendar API call
    function calEventsLoadComplete(data, state) {
        // save loaded data, then prep 'locations' select
        calEvents[state] = data;
        // With our events loaded, we can now enable the locations field
        setLocationsActive(true);
    }

    // Using the gathered event list, prep date fields for
    // user selections.  NOT IN USE...?
    function prepDateSelections(eventList) {

        setDatesActive(true);
    }

    // Handle successful form submission.
    function handleSuccess() {
        var msg = '<div class="ok">';
        msg += '<h3>Message Sent!</h3>';
        msg += '<p>Thank you for submitting your inquiry. ';
        msg += 'We will be in contact with you shortly.</p></div>';
        $form.parent().append(msg);
        $form.slideUp();
    }

    // Handle form submission errors
    function handleIncomplete(errData) {
        var err = '<div id="errorList">';
        err += '<h3>Please correct the following errors:</h3>';
        err += '<ul class="error-list">';
        for (var item in errData) {
            err += '<li>' + errData[item] + '</li>';
        }
        err += '</ul>';
        // Remove existing errors (if any)
        $form.find('#errorList').remove();
        // Then add our new list
        $form.find('.form__error-messaging').after(err);
        $(window).scrollTo('#' + $form.attr('id') + ' #errorList', 750);
    }

    function deactivateForm() {
        var submitBtn = $form.find('.submit'),
            loader = $form.find('.form__loader');
        submitBtn.prop('disabled', true);
        submitBtn.addClass('form__button-inactive');
        loader.addClass('is-opaque');
    }

    function activateForm() {
        var submitBtn = $form.find('.submit'),
            loader = $form.find('.form__loader');
        submitBtn.prop('disabled', false);
        submitBtn.removeClass('form__button-inactive');
        loader.removeClass('is-opaque');
    }

    function wireEvents() {

        // Hook up fundraising form
        $stateSelect.change(function(evt){
            // Handle state selection
            doStateSelect($(this).val());
        });
        $locSelect.change(function(evt) {
            // Handle location selection
            var selectedItem, locId, calId, days;
            selectedItem = $(this).find(':selected');
            locId   = selectedItem.val();
            locText = selectedItem.text();
            calId   = selectedItem.data('calendar-id');
            days    = selectedItem.data('days');
            doLocationSelect(locId, locText, calId, days);
        });

        // Prep form for ajax posting

        $form.on('submit', function(evt) {
            var formData = new FormData($(this)[0]); // $form.serialize();
            evt.preventDefault();

            deactivateForm();

            $.ajax({
                url : '',
                method: 'POST',
                data: formData,
                async: true,
                cache: false,
                contentType: false,
                processData: false,
                success: function(response, textStatus, jqXHR){
                    // handle server response
                    // console.log(response);
                    if (response.ok == "yes") {
                        handleSuccess();
                    } else {
                        activateForm();
                        handleIncomplete(response.errors);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown){
                    //do something for error
                    alert("We're sorry, but please try again later.");
                    activateForm();
                    console.log('errorThrown: ', errorThrown);
                    console.log('textStatus: ', textStatus);
                }
            });

            return false;
        });
    }

    exports.init = function() {
        // Set shortcuts for our various form elements
        $form = $('#fundraiserDateRequest');
        $stateSelect = $('#fundraiserDateRequest_state');

        // NOTE: the location selection field exists as a hidden field
        // within the 'formerly' form.  We dynamically manage the contents
        // of the dropdown that we add in the front-end to allow for user
        // selection from a dynamic list, and then write the selection to
        // the simple text field used by the form.
        $locSelect = $('#select-location');
        $locSelectValue = $('#fundraiserDateRequest_location');

        $date1 = $('#fundraiserDateRequest_dateChoice1');
        $date2 = $('#fundraiserDateRequest_dateChoice2');
        $date3 = $('#fundraiserDateRequest_dateChoice3');
        dateFields = [$date1,$date2,$date3];
        pickers = [];

        // Initialize and store each of our date pickers
        $.each(dateFields, function(index, el) {
            var $input = el.pickadate({
                    format:'mmmm d, yyyy',
                    min:true,
                    max:90
                });
            var picker = $input.pickadate('picker');
            picker.on({
                close: function() {
                    // On close, we want to re-init any remaining pickers so as to block
                    // out the date that was just selected.
                    var pickersRemaining = null,
                        thisPickerId = $(this.$node.context).attr('id');

                    if (thisPickerId == $date1.attr('id')) {
                        pickersRemaining = [pickers[1], pickers[2]];
                    } else if (thisPickerId == $date2.attr('id')) {
                        pickersRemaining = [pickers[2]];
                    }

                    // Add the just-selected date to the collection of blocked dates
                    currTakenDates.push(new Date(this.get()));

                    // If any dates are remaining to be filled, re-initialize them
                    $.each(pickersRemaining, function(index, picker) {
                        initPicker(picker);
                    });
                }
            });
            pickers.push(picker);
        });

        // Deactive the date and location fields (user needs to select
        // a state before these become active)
        setLocationsActive(false);
        setDatesActive(false);

        // Wire events for the form
        wireEvents();

    };

    // exports.calEvents = calEvents;

    return exports;

})(Otto, jQuery);

